/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Enter_New_PasswordInputs */

const en_common_enter_new_password = /** @type {(inputs: Common_Enter_New_PasswordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enter new password`)
};

const es_common_enter_new_password = /** @type {(inputs: Common_Enter_New_PasswordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingresa la nueva contraseña`)
};

/**
* | output |
* | --- |
* | "Enter new password" |
*
* @param {Common_Enter_New_PasswordInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const common_enter_new_password = /** @type {((inputs?: Common_Enter_New_PasswordInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Enter_New_PasswordInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_common_enter_new_password(inputs)
	return en_common_enter_new_password(inputs)
});